// Route: '/play/result/:playerid'
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { MyInfoCircle } from './PlayResultPage.styles';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Main } from '../../styles';
import { PageTitle } from '../ResultPage/ResultPage.styles';
import Nav from '../../components/Nav/Nav';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { StoreContext } from '../../utils/store';
import { ImCheckmark, ImCross } from 'react-icons/im';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

const ResultPage = () => {
  const { playerid } = useParams();
  const context = useContext(StoreContext);
  const history = useHistory();
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;

  // result info states

  const [score, setScore] = useState(0);
  const [results, setResults] = useState([]);
  const [performances, setPerformances] = useState([]);
  const [timeTaken, setTimeTaken] = useState([]);
  const [points, setPoints] = useState([]);
  // material ui styles
  const useStyles = makeStyles({
    tableContainer: {
      margin: 20,
      minWidth: 350,
      maxWidth: 650,
    },
    table: {
      minWidth: 350,
      maxWidth: 650,
      width: '90%',
      margin: '0 auto',
      '& th': {
        fontSize: '1.2em',
        fontWeight: 'bold',
      },
      '& td': {
        fontSize: '1em',
      },
    },
    greencheck: {
      color: '#66bb6a',
    },
    redcross: {
      color: '#ef5350',
    },
    message: {
      fontSize: '1.2em',
    }
  });

  const InfoTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: '#333333',
      maxWidth: 250,
      fontSize: theme.typography.pxToRem(14),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);
  const classes = useStyles();

  // api call functions
  const getResults = async () => {
    const response = await api.makeAPIRequest(`play/${playerid}/results`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        return json;
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  // states setup
  useEffect(async () => {
    const r = await getResults();
    setResults(r);
    let newScore = 0;
    const newPerformances = [];
    const newTimeTaken = [];
    const newPoints = [];
    r.forEach((q, idx) => {
      console.log(q);
      newTimeTaken[idx] = Math.round((new Date(q.answeredAt) - new Date(q.questionStartedAt)) / 1000);
      if (q.correct) {
        newPoints[idx] = Math.round(q.questionPoints * (1 - (newTimeTaken[idx] / (q.questionDuration - 0.5))));
        newScore += newPoints[idx];
        newPerformances[idx] = true;
      } else {
        newPerformances[idx] = false;
        newPoints[idx] = 0;
      }
    });
    setScore(newScore);
    setPoints(newPoints);
    setPerformances(newPerformances);
    console.log(performances);
    console.log(newPerformances);
    setTimeTaken(newTimeTaken);
  }, []);

  return (

    <section>
      <Nav
        visibilities={['false', 'false', 'false', 'true', 'false']}
        exit={() => history.push('/')}
      />
      <Main>
        <PageTitle>Game result</PageTitle>
        <p className={classes.message}>
          You scored <strong>{score}</strong> points out of {results.reduce((accumulator, currentValue) => accumulator + currentValue.questionPoints, 0)}, {score > (results.reduce((accumulator, currentValue) => accumulator + currentValue.questionPoints, 0) / 2) ? 'well done!' : 'You can do better next time.'}
        </p>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table} aria-label='caption table'>
            <caption>Player Performance</caption>
            <TableHead>
              <TableRow>
                <TableCell align='center'>Question</TableCell>
                <TableCell align='center'>Result</TableCell>
                <TableCell align='center'>Time Taken</TableCell>
                <TableCell align='center'>
                  Points
                  <InfoTooltip title={
                                  <>
                                    <Typography color='inherit'>Points scored are the product of the percentage of time left and total points of the question.</Typography>
                                    <em><b>{'Equation: '}</b>{'points = (1 - (time taken/duration)) * total points'}</em><br/>
                                  </>
                                }>
                    <span>
                      <MyInfoCircle />
                    </span>
                  </InfoTooltip>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results &&
              <>
              {results.map((q, idx) => (
                  <TableRow key={idx}>
                    <TableCell align='center'>
                      {idx + 1 + ''}
                    </TableCell>
                    <TableCell align='center'>
                      {q.correct
                        ? <ImCheckmark className={classes.greencheck}/>
                        : <ImCross className={classes.redcross}/>
                      }
                    </TableCell>
                    <TableCell align='center'>
                      {timeTaken[idx] === 0
                        ? <>Not answered</>
                        : timeTaken[idx] + '/' + (results[idx].questionDuration - 0.5)
                      }
                    </TableCell>
                    <TableCell align='center'>
                      {`${points[idx]}/${results[idx].questionPoints}`}
                    </TableCell>
                  </TableRow>
              ))}
              </>
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Main>
    </section>

  );
};

export default ResultPage;
